import React from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import BackIcon from './BackIcon'
import { palette } from '../../../style/theme'
import { useHistory } from 'react-router-dom'

const Button = styled.div`
  color: white;
  display: flex;
  font-size: min(1vw, 35px);
  align-items: center;
`

const IconWrapper = styled.div`
  border-radius: 1vw;
  padding: 0.75vw;
  background-color: ${palette.biscay};
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 1.25em;
    height: 1.25em;
  }
`

const Text = styled.div`
  padding: 1vw;
  text-transform: capitalize;
`

type Props = {
  className?: string
}

const BackButton: React.FC<Props> = ({ className }) => {
  const history = useHistory()
  const { t } = useTranslation()

  return (
    <Button className={className} onClick={() => history.goBack()}>
      <IconWrapper>
        <BackIcon />
      </IconWrapper>
      <Text>{t('AA.back')}</Text>
    </Button>
  )
}

export default BackButton
